// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__1rlBM","formSpace":"styles_formSpace__2nmrP","actionButton":"styles_actionButton__2Z7b4","actionIcon":"styles_actionIcon__muW73"};